import { render, staticRenderFns } from "./AccountsIndex.vue?vue&type=template&id=4a52da68"
import script from "./AccountsIndex.vue?vue&type=script&lang=js"
export * from "./AccountsIndex.vue?vue&type=script&lang=js"
import style0 from "./AccountsIndex.vue?vue&type=style&index=0&id=4a52da68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports